import DescriptionIcon from '@material-ui/icons/Description';
import PersonIcon from '@material-ui/icons/Person';
import AddIcCallIcon from '@material-ui/icons/AddIcCall';
import CommentIcon from '@material-ui/icons/Comment';
import PhoneIcon from '@material-ui/icons/Phone';
import GroupWorkIcon from '@material-ui/icons/GroupWork';
import WorkIcon from '@material-ui/icons/Work';
import ReportProblemIcon from '@material-ui/icons/ReportProblem';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import PaymentIcon from '@material-ui/icons/Payment';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import StoreIcon from '@material-ui/icons/Store';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import CropLandscapeIcon from '@material-ui/icons/CropLandscape';
import ControlPointIcon from '@material-ui/icons/ControlPoint';
import ListIcon from '@material-ui/icons/List';
import ExposureIcon from '@material-ui/icons/Exposure';
import PublicIcon from '@material-ui/icons/Public';
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter';
import CategoryIcon from '@material-ui/icons/Category';
import RoomIcon from '@material-ui/icons/Room';
import TransferWithinAStationIcon from '@material-ui/icons/TransferWithinAStation';
import EditIcon from '@material-ui/icons/Edit';
import { useTranslation } from 'react-i18next';
import MenuBookSharpIcon from '@material-ui/icons/MenuBookSharp';
import ImportContactsIcon from '@material-ui/icons/ImportContacts';
import SupportIcon from '@material-ui/icons/ContactSupport';
import HeadsetMicIcon from '@material-ui/icons/HeadsetMic';
import DomainIcon from '@material-ui/icons/Domain';
import StorefrontIcon from '@material-ui/icons/Storefront';
import LoyaltyIcon from '@material-ui/icons/Loyalty';
import GroupAddIcon from '@material-ui/icons/GroupAdd';
import SwapHorizontalCircleIcon from '@material-ui/icons/SwapHorizontalCircle';
import PostAddIcon from '@material-ui/icons/PostAdd';
import ReportIcon from '@material-ui/icons/Assessment';
import AdjustIcon from '@material-ui/icons/Adjust';
import AddLocationIcon from '@material-ui/icons/AddLocation';
import GroupWorkOutlinedIcon from '@material-ui/icons/GroupWorkOutlined';
import ThumbDownAltIcon from '@material-ui/icons/ThumbDownAlt';
import SurroundSoundIcon from '@material-ui/icons/SurroundSound';
import BrandingWatermarkIcon from '@material-ui/icons/BrandingWatermark';
import TouchAppIcon from '@material-ui/icons/TouchApp';
import HelpIcon from '@material-ui/icons/Help';
import TimerIcon from '@material-ui/icons/Timer';
import DynamicFeedIcon from '@material-ui/icons/DynamicFeed';
import TextsmsIcon from '@material-ui/icons/Textsms';
import ScoreIcon from '@material-ui/icons/Score';
import SettingsBackupRestoreIcon from '@material-ui/icons/SettingsBackupRestore';
import AlarmAddIcon from '@material-ui/icons/AlarmAdd';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import ControlCameraIcon from '@material-ui/icons/ControlCamera';
import PhonelinkSetupIcon from '@material-ui/icons/PhonelinkSetup';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import DirectionsRunIcon from '@material-ui/icons/DirectionsRun';
import StorefrontTwoToneIcon from '@material-ui/icons/StorefrontTwoTone';
import AddAlertIcon from '@material-ui/icons/AddAlert';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import TitleRoundedIcon from '@material-ui/icons/TitleRounded';
import QuestionAnswerIcon from '@material-ui/icons/QuestionAnswer';
import StreetviewIcon from '@material-ui/icons/Streetview';
import MenuOpenIcon from '@material-ui/icons/MenuOpen';
import AssignmentIcon from '@material-ui/icons/Assignment';
import ListAltIcon from '@material-ui/icons/ListAlt';
import SaveIcon from '@material-ui/icons/Save';
import DashboardIcon from '@material-ui/icons/Dashboard';
import WorkOffIcon from '@material-ui/icons/WorkOff';
import TranslateIcon from '@material-ui/icons/Translate';
import LowPriorityIcon from '@material-ui/icons/LowPriority';
import CheckIcon from '@material-ui/icons/Check';
import SentimentVerySatisfiedIcon from '@material-ui/icons/SentimentVerySatisfied';
import AirportShuttleIcon from '@material-ui/icons/AirportShuttle';
import LibraryAddIcon from '@material-ui/icons/LibraryAdd';
import LaunchIcon from '@material-ui/icons/Launch';
import LiveHelp from '@material-ui/icons/LiveHelp';
import DonutSmallIcon from '@material-ui/icons/DonutSmall';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import AssessmentOutlinedIcon from '@material-ui/icons/AssessmentOutlined';
import AddBoxOutlinedIcon from '@material-ui/icons/AddBoxOutlined';
import PersonOutlineOutlinedIcon from '@material-ui/icons/PersonOutlineOutlined';
import StoreOutlinedIcon from '@material-ui/icons/StoreOutlined';
import { getUser } from 'src/utils/Common';
import AssessmentIcon from '@material-ui/icons/Assessment';
import ConfirmationNumberIcon from '@material-ui/icons/ConfirmationNumber';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import BugReportIcon from '@material-ui/icons/BugReport';
import GamesIcon from '@material-ui/icons/Games';

const StartMenu = () => {
  const SessionUser = getUser();
  const { t } = useTranslation('Catalog');
  return [
    {
      title: t('lblDashboard'),
      href: '/Dashboard',
      icon: DashboardIcon,
    },
    ...(SessionUser.TenantId === 16 ? [{
      title: t('lblTradePartnerExternalClaimControl'),
      href: '/TradePartner',
      icon: GroupWorkIcon,
     }] : []),
    {
      title: t('lblCatalogDefinitions'),
      href: '/Catalog',
      icon: DescriptionIcon,
      items: [
        {
          title: t('lblAdhocQuery'),
          icon: DynamicFeedIcon,
          href: '/Catalog/AdhocQuery',
          id: 57
        },
        {
          title: t('lblChannel'),
          icon: AddIcCallIcon,
          href: '/Catalog/Channel',
          id: 1
        },
        {
          title: t('lblCommentTypes'),
          icon: CommentIcon,
          href: '/Catalog/CommentType',
          id: 2
        },
        {
          title: t('lblPriority'),
          icon: LowPriorityIcon,
          href: '/Catalog/Priority',
          id: 59
        },
        {
          title: t('lblVerificationRules'),
          icon: CheckIcon,
          href: '/Catalog/VerificationRules',
          id: 60
        },
        {
          title: t('lblSurveyQuestionAnswer'),
          icon: SentimentVerySatisfiedIcon,
          href: '/Catalog/SurveyQuestionAnswer',
          id: 61
        },
        {
          title: t('lblConsumerTypes'),
          icon: PersonIcon,
          href: '/Catalog/ConsumerTypes',
          id: 3
        },
        {
          title: t('lblPhoneTypes'),
          icon: PhoneIcon,
          href: '/Catalog/ConsumerPhoneTypes',
          id: 4
        },
        {
          title: t('lblAddressTypes'),
          icon: AddLocationIcon,
          href: '/Catalog/ConsumerAdressTypes',
          id: 5
        },
        {
          title: t('lblPlaceTypes'),
          icon: RoomIcon,
          href: '/Catalog/Places',
          id: 6
        },
        // {
        //   title: t('lblServiceShopType'),
        //   icon: StorefrontIcon,
        //   href: '/Catalog/ServiceShopTypes',
        //   id: 7
        // },

        {
          title: t('lblPaymentTypes'),
          icon: PaymentIcon,
          href: '/Catalog/PaymentTypes',
          id: 9
        },
        {
          title: t('Task Types'),
          icon: AssignmentIcon,
          href: '/Catalog/TaskType',
          id: 84
        },
        {
          title: t('lblDynamicGroup'),
          icon: GroupWorkOutlinedIcon,
          href: '/Catalog/DynamicGroup',
          id: 103
        },
        {
          title: t('lblTechnology'),
          icon: DonutSmallIcon,
          href: '/Catalog/Technology',
          id: 102
        },
        {
          title: t('lblPdfRulesForPriceFields'),
          icon: PaymentIcon,
          href: '/Catalog/PdfRulesForPriceFields',
          id: 85
        },
        {
          title: t('lblVulnerabilities'),
          icon: TouchAppIcon,
          href: '/Catalog/Vulnerabilities',
          id: 11
        },
        {
          title: t('lblCustomerTitles'),
          icon: TitleRoundedIcon,
          href: '/Catalog/CustomerTitles',
          id: 12
        },
        {
          title: t('lblTranslation'),
          icon: TranslateIcon,
          href: '/Catalog/Translation',
          id: 56
        }
      ]
    },
    {
      title: t('lblOrganization'),
      href: '/Organization',
      icon: PeopleAltIcon,
      items: [
        {
          title: t('lblExcelUpload'),
          href: '/Organization/ExcelUpload',
          icon: CloudUploadIcon,
          id: 1001
        },
        {
          title: t('TicketManagement'),
          href: '/Organization/TicketManagement',
          icon: BugReportIcon,
          id: 1002
        },
        {
          title: t('lblServiceShop'),
          icon: StoreIcon,
          href: '/Organization/ServiceShop',
          id: 14
        },
        {
          title: t('lblEmployee'),
          icon: AssignmentIndIcon,
          href: '/Organization/Employee',
          id: 15
        },
        {
          title: t('lblPostCodeMapService'),
          icon: PostAddIcon,
          href: '/Catalog/ServiceShopPostCodeMap',
          id: 16
        },
        {
          title: t('Monthly Transportation'),
          icon: PostAddIcon,
          href: '/Catalog/MonthlyTransportation',
          id: 161
        },
        {
          title: t('lblRetailer'),
          icon: LoyaltyIcon,
          href: '/Organization/Retailer',
          id: 17
        },
        {
          title: t('lblUserType'),
          icon: GroupAddIcon,
          href: '/Organization/UserTypes',
          id: 18
        },
        {
          title: t('lblUserAuthority'),
          icon: PublicIcon,
          href: '/Organization/UserAuthority',
          id: 19
        },
        {
          title: t('lblMenuAuthorization'),
          icon: MenuOpenIcon,
          href: '/MasterDataManagement/MenuAuthorization',
          id: 46
        },
        {
          title: t('Comment User Authorization'),
          icon: MenuOpenIcon,
          href: '/MasterDataManagement/CommentUserAuthorization',
          id: 108
        },
        {
          title: t('lblPaymentTypeTenant'),
          icon: MenuOpenIcon,
          href: '/Organization/PaymentTypeTenant',
          id: 19
        }
      ]
    },
    {
      title: t('lblOperation'),
      href: '/Operation',
      icon: TransferWithinAStationIcon,
      items: [
        {
          title: t('lblBulkUpload'),
          href: '/Operation/BulkUpload',
          icon: AddBoxOutlinedIcon,
          id: 10002,
          items: [
            {
              title: t('lblWorkOrderUpload'),
              href: '/Operation/BulkUpload/WorkOrderUpload',
              icon: StoreOutlinedIcon,
              id: 10003
            },
            {
              title: t('lblNpsUpload'),
              href: '/Operation/BulkUpload/NpsUpload',
              icon: StoreOutlinedIcon,
              id: 10004
            },
          ]
        },
        {
          title: t('lblJobControl'),
          icon: EditIcon,
          href: '/Operation/JobControl',
          id: 20
        },
        {
          title: t('lblScheduling'),
          icon: EditIcon,
          href: '/Operation/Scheduling',
          id: 2020
        },
        {
          title: t('lblWorkBench'),
          icon: ListAltIcon,
          href: '/Operation/WorkBench',
          id: 211
        },
        {
          title: t('lblTriage'),
          icon: AssessmentIcon,
          href: '/Operation/Triage',
          id: 213
        },
         {
          title: t('ShipToManagement'),
          href: '/Operations/ShipToManagement',
          icon: LocalShippingIcon,
          id: 1003
        },
        {
          title: t('MaterialManagement'),
          href: '/Operations/MaterialManagement',
          icon: GamesIcon,
          id: 1004
        },
        {
          title: t('lblCustomerFeedback'),
          icon: SettingsBackupRestoreIcon,
          href: '/Operation/CustomerFeedback',
          id: 21
        },
        {
          title: t('lblProductExchange'),
          icon: ControlPointIcon,
          href: '/Operation/ProductExchange',
          id: 22
        },
        {
          title: t('lblWaitingForDiscountApprovel'),
          icon: LocalOfferIcon,
          href: '/Operation/WaitingForDiscountApproval',
          id: 251
        },
        {
          title: t('lblManualDiscount'),
          icon: LocalOfferIcon,
          href: '/Operation/ManualDiscount',
          id: 252
        },
        {
          title: t('lblAccounting'),
          icon: AccountBalanceIcon,
          href: '/Operation/Accounting',
          id: 23
        },
        {
          title: t('lblAccountingFinalOperations'),
          icon: AssignmentIcon,
          href: '/Operation/AccountingFinalOperations',
          id: 231
        },
        {
          title: t('lblMaterialOrder'),
          href: '/Operation/MaterialOrder',
          icon: ShoppingCartIcon,
          id: 24,
          items: [
            {
              title: t('lblQuery'),
              href: '/Operation/MaterialOrder/Query',
              icon: AssessmentOutlinedIcon,
              id: 111
            },
            {
              title: t('lblCreate'),
              href: '/Operation/MaterialOrder/Create',
              icon: AddBoxOutlinedIcon,
              items: [
                ...(SessionUser.TenantId == 87 || SessionUser.TenantId == 16 ? [{
                  title: t('lblForConsumer'),
                  href: '/Operation/MaterialOrder/Create/ForConsumer',
                  icon: PersonOutlineOutlinedIcon,
                  id: 222
                }] : []),
                {
                  title: t('lblForPartner'),
                  href: '/Operation/MaterialOrder/Create/ForPartner',
                  icon: StoreOutlinedIcon,
                  id: 333
                },
              ]
            }
          ]
        },
        {
          title: t('lblServiceCapacity'),
          icon: WorkIcon,
          href: '/Operation/ServiceCapacity',
          id: 25
        },
        {
          title: t('lblSmsNpsManual'),
          icon: SurroundSoundIcon,
          href: '/Operation/SmsNpsManual',
          id: 64
        },

        {
          title: t('lblAnnouncement'),
          icon: AddAlertIcon,
          href: '/OperationCatalog/Announcement',
          id: 26
        },
        {
          title: t('lblMaterialImage'),
          icon: StreetviewIcon,
          href: '/Operation/MaterialPhotoUploader',
          id: 27
        },
        {
          title: t('lblFleetManagement'),
          icon: AirportShuttleIcon,
          href: '/Operation/FleetCostManagement',
          id: 65
        },
        {
          title: t('lblReworkUpload'),
          icon: StoreIcon,
          href: '/Operation/UploadRework',
          id: 651
        },
        {
          title: t('lblExcelToCase'),
          icon: StoreIcon,
          href: '/Operation/ExcelToCase',
          id: 654
        },
        {
          title: t('lblMaterialServiceShop'),
          icon: AssignmentIcon,
          href: '/Operation/MaterialServiceShop',
          id: 652
        },
        {
          title: t('lblCompensationReport'),
          icon: AccountBalanceWalletIcon,
          href: '/Operation/Compensation',
          id: 556
        },
        {
          title: t('lblSparePartOrderManagement'),
          icon: LaunchIcon,
          href: '/Operation/SparePartOrderManagement',
          id: 104
        },
        {
          title: t('Grade Posting'),
          icon: WorkIcon,
          href: '/Operation/GradePosting',
          id: 653
        },
        {
          title: t('lblOfferSMS'),
          icon: SurroundSoundIcon,
          href: '/Operation/OfferSMS',
          id: 558
        },
        {
          title: t('lblAutomaticSAPDocuments'),
          icon: PostAddIcon,
          href: '/Operation/AutomaticSAPDocuments',
          id: 559
        },
        {
          title: t('lblSerialNr'),
          icon: ConfirmationNumberIcon,
          href: '/Operation/SerialNumber',
          id: 561
        },
        {
          title: t('lblCaseOwner'),
          icon: GroupAddIcon,
          href: '/Operation/CaseOwner',
          id: 560
        },
        {
          title: t('lblTaskManagement'),
          icon: AssignmentIcon,
          href: '/OperationCatalog/TaskManagement',
          id: 53
        },
      ]
    },
    {
      title: t('lblOperationCatalog'),
      href: '/OperationCatalog',
      icon: CategoryIcon,
      items: [
        {
          title: t('lblApplicationTypeProductMatching'),
          icon: BusinessCenterIcon,
          href: '/Catalog/ApplicationType-ProductMatching',
          id: 261
        },
        {
          title: t('lblTypeProductEdit'),
          icon: BusinessCenterIcon,
          href: '/Catalog/TypeProductEdit',
          id: 271
        },
        {
          title: t('lblSKUAttachments'),
          icon: BusinessCenterIcon,
          href: '/Catalog/SKU-Attachments',
          id: 311
        },
        {
          title: t('lblProductGroupAttachments'),
          icon: BusinessCenterIcon,
          href: '/Catalog/Product-Group-Attachments',
          id: 322
        },
        {
          title: t('Schemes'),
          icon: BusinessCenterIcon,
          href: '/Catalog/Schemes',
          id: 321
        },
        {
          title: t('lblStatus'),
          icon: BusinessCenterIcon,
          href: '/Catalog/Status',
          id: 28
        },
        {
          title: t('Status Updater'),
          href: '/Catalog/StatusUpdater',
          icon: LiveHelp,
          id: 30
        },
        {
          title: t('lblStatusManagement'),
          icon: DomainIcon,
          href: '/OperationCatalog/StatusManagement',
          id: 29
        },
        {
          title: t('lblServiceShopDiscountManagement'),
          icon: LocalOfferIcon,
          href: '/OperationCatalog/ServiceShopDiscountGradeManagement',
          id: 5187
        },
        {
          title: t('lblServiceShopStorageLocationManagement'),
          icon: LocalOfferIcon,
          href: '/OperationCatalog/ServiceShopStorageLocationManagement',
          id: 5188
        },
        {
          title: t('lblServiceShopPaymentGroupManagement'),
          icon: LocalOfferIcon,
          href: '/OperationCatalog/ServiceShopPaymentGroupManagement',
          id: 5189
        },
        {
          title: t('lblNotificationCenter'),
          icon: DomainIcon,
          href: '/OperationCatalog/NotificationCenter',
          id: 62
        },
        // {
        //   title: t('lblExchangeStatus'),
        //   icon: SwapHorizIcon,
        //   href: '/OperationCatalog/ExchangeStatus',
        //   id: 30
        // },
        {
          title: t('lblExchangeReason'),
          icon: SwapHorizontalCircleIcon,
          href: '/OperationCatalog/ExchangeReason',
          id: 31
        },
        {
          title: t('lblExchangeReasonDetails'),
          icon: SwapHorizontalCircleIcon,
          href: '/OperationCatalog/ExchangeReasonDetail',
          id: 123
        },
        {
          title: t('lblWarrantyTypes'),
          icon: VerifiedUserIcon,
          href: '/Catalog/WarrantyTypes',
          id: 32
        },
        {
          title: t('lblProductWarrantyTime'),
          icon: TimerIcon,
          href: '/Catalog/WarrantyPeriods',
          id: 33
        },
        {
          title: t('lblWarrantyTimeExceptions'),
          icon: AlarmAddIcon,
          href: '/Catalog/WarrantyTimeExceptions',
          id: 34
        },
        {
          title: t('lblFls'),
          icon: MenuBookSharpIcon,
          href: '/Catalog/Fls',
          id: 35
        },
        {
          title: t('lblApplicationType'),
          icon: ReportProblemIcon,
          href: '/Catalog/ApplicationType',
          id: 36
        },
        {
          title: t('lblRejectReason'),
          icon: ThumbDownAltIcon,
          href: '/Catalog/RejectReasons',
          id: 37
        },
        {
          title: t('CancellationReason'),
          icon: ThumbDownAltIcon,
          href: '/Catalog/CancellationReasons',
          id: 371
        },
        {
          title: t('lblVerificationExecuteRules'),
          icon: ControlCameraIcon,
          href: '/OperationCatalog/VerificationExecuteRules',
          id: 38
        },
        {
          title: t('lblToinform'),
          icon: PhonelinkSetupIcon,
          href: '/Catalog/Toinfo',
          id: 39
        },
        {
          title: t('lblBrand'),
          icon: BrandingWatermarkIcon,
          href: '/OperationCatalog/Brand',
          id: 8
        },
        {
          title: t('lblPlant'),
          icon: CropLandscapeIcon,
          href: '/OperationCatalog/Plants',
          id: 10
        },
        {
          title: t('lblSupport'),
          icon: HelpIcon,
          href: '/OperationCatalog/Support',
          id: 13
        },
        {
          title: t('ReworkStatus'),
          icon: AlarmAddIcon,
          href: '/Catalog/ReworkStatus',
          id: 66
        },
        {
          title: t('lblSparePartMap'),
          icon: LibraryAddIcon,
          href: '/OperationCatalog/SparePartMap',
          id: 555
        },
        {
          title: t('lblProductAlternativeMap'),
          icon: LibraryAddIcon,
          href: '/OperationCatalog/ProductAlternative',
          id: 10001
        },
        {
          title: t('Survey Module'),
          icon: PhonelinkSetupIcon,
          href: '/OperationCatalog/SurveyModule',
          id: 557
        }
      ]
    },
    {
      title: t('lblPriceMamagement'),
      href: '/PriceManagement',
      icon: PaymentIcon,
      items: [
        {
          title: t('lblPriceGroups'),
          icon: LocalOfferIcon,
          href: '/MasterDataManagement/PriceGroups',
          id: 40
        },
        {
          title: t('lblPaymentGroups'),
          icon: AccountBalanceWalletIcon,
          href: '/Catalog/PaymentGroups',
          id: 41
        },
        {
          title: t('lblTransportPrice'),
          icon: LocalShippingIcon,
          href: '/MasterDataManagement/TransportPrices',
          id: 42
        },
        {
          title: t('lblPriceOperation'),
          icon: ExposureIcon,
          href: '/MasterDataManagement/PriceOperation',
          id: 63
        },
        {
          title: t('lblRevenuePrices'),
          icon: LocalOfferIcon,
          href: '/MasterDataManagement/RevenuePrices',
          id: 105
        },
        {
          title: t('lblInterventionControl'),
          icon: ExposureIcon,
          href: '/MasterDataManagement/InterventionControl',
          id: 106
        },
        {
          title: t('lblNoRevenueDefects'),
          icon: ExposureIcon,
          href: '/MasterDataManagement/NoRevenueDefects',
          id: 107
        }
      ]
    },
    {
      title: t('lblMasterDataMamagement'),
      href: '/MasterDataManagement',
      icon: AdjustIcon,
      items: [
        {
          title: t('lblDefect'),
          icon: GroupWorkIcon,
          href: '/MasterDataManagement/Defects',
          id: 43
        },
        {
          title: t('lblProductLaunch'),
          icon: LaunchIcon,
          href: '/MasterDataManagement/ProductLaunch',
          id: 101
        },
        {
          title: t('lblLabour'),
          icon: WorkIcon,
          href: '/Catalog/Labour',
          id: 44
        },
        {
          title: t('lblProductLabourRelation'),
          icon: WorkIcon,
          href: '/MasterDataManagement/ProductLabourRelation',
          id: 45
        },
        {
          title: t('lblDefinedValues'),
          icon: SaveIcon,
          href: '/MasterDataManagement/DefinedValues',
          id: 53
        },
        {
          title: t('lblLabourOperation'),
          icon: ExposureIcon,
          href: '/MasterDataManagement/LabourOperation',
          id: 64
        },
        {
          title: t('Conjugate'),
          icon: SaveIcon,
          href: '/MasterDataManagement/Conjugate',
          id: 65
        },
        {
          title: t('MaterialConjugate'),
          icon: SaveIcon,
          href: '/MasterDataManagement/MaterialConjugate',
          id: 66
        }
      ]
    },
    {
      title: t('lblReports'),
      href: '/Reports',
      icon: ListIcon,
      items: [
        {
          title: t('lblGeneralReports'),
          icon: ReportIcon,
          href: '/Reports/GeneralReports',
          id: 591
        },
        {
          title: t('lblAdhocQuery'),
          icon: DynamicFeedIcon,
          href: '/Reports/AdhocQuery',
          id: 47
        },
        {
          title: t('lblAdhocQueryNew'),
          icon: DynamicFeedIcon,
          href: '/Reports/AdhocQuery/New',
          id: 70
        },
        // {
        //   title: t('lblSms'),
        //   icon: TextsmsIcon,
        //   href: '/Reports/Sms',
        //   id: 48
        // },
        // {
        //   title: t('lblNps'),
        //   icon: ScoreIcon,
        //   href: '/Reports/Nps',
        //   id: 49
        // },
        {
          title: t('lblWarrantyException'),
          icon: AlarmAddIcon,
          href: '/Reports/WarrantyException',
          id: 55
        },
        {
          title: t('GCC Dashboard'),
          icon: DirectionsRunIcon,
          href: 'https://atlas.arcelik.com',
          id: 50
        },
        {
          title: t('lblServiceShopMaterial'),
          icon: StorefrontTwoToneIcon,
          href: '/Reports/ServiceShopMaterial',
          id: 51
        },
        {
          title: t('lblServiceShopOffWork'),
          icon: WorkOffIcon,
          href: '/Reports/ServiceShopOffWork',
          id: 52
        },
        {
          title: t('lblTechnicianOffWork'),
          icon: WorkOffIcon,
          href: '/Reports/TechnicianOffWork',
          id: 66
        },
        {
          title: t('lblCountryCard'),
          icon: QuestionAnswerIcon,
          href: '/Reports/CountryCard',
          id: 54
        },
        {
          title: t('lblPostCode'),
          icon: PostAddIcon,
          href: '/Reports/PostCode',
          id: 58
        },
        {
          title: t('Integration Control'),
          icon: PostAddIcon,
          href: '/Reports/IntegrationControl',
          id: 58
        },
        {
          title: t('Gateway Integration Control'),
          icon: SwapHorizontalCircleIcon,
          href: '/Reports/GatewayIntegrationControl',
          id: 58
        }
        // ,
        // {
        //   title: t('lblReworkPdf'),
        //   icon: TextsmsIcon,
        //   href: '/Reports/ReworkPdf',
        //   id: 47
        // }
      ]
    },
    {
      title: 'Setup Tenant',
      href: '/SetupTenant',
      icon: MenuOpenIcon,
      items: [
        {
          title: 'Setup Tenant',
          icon: MenuOpenIcon,
          href: '/SetupTenant',
          id: 250
        },
        {
          title: 'Create Tenant',
          icon: StorefrontIcon,
          href: '/SetupTenant/Create',
          id: 259
        },
        {
          title: 'Create Service Shop',
          icon: StorefrontIcon,
          href: '/SetupTenant/ServiceShop',
          id: 260
        },
        {
          title: 'Add Update Product Material',
          icon: StorefrontIcon,
          href: '/SetupTenant/AddUpdateProductMaterial',
          id: 420
        },
        {
          title: 'Create Employee',
          icon: AssignmentIndIcon,
          href: '/SetupTenant/Employee',
          id: 270
        },
        {
          title: 'Service Shop Employee Matching',
          icon: StoreIcon,
          href: '/SetupTenant/ServiceEmployeeMatching',
          id: 310
        },
        {
          title: 'Create Location',
          icon: AddLocationIcon,
          href: '/SetupTenant/Location',
          id: 320
        },
        {
          title: 'Create Retailer',
          icon: LoyaltyIcon,
          href: '/SetupTenant/Retailer',
          id: 280
        },
        {
          title: 'Create Distributer',
          href: '/SetupTenant/Distributer',
          icon: LiveHelp,
          id: 300
        },
        {
          title: 'Post Code Service Shop',
          icon: PostAddIcon,
          href: '/SetupTenant/PostCodeServiceShop',
          id: 290
        },
        {
          title: 'Create Vat & Currency',
          icon: LocalOfferIcon,
          href: '/SetupTenant/VatCurrency',
          id: 240
        },
        {
          title: 'Create Product',
          icon: BusinessCenterIcon,
          href: '/SetupTenant/Product',
          id: 319
        },
        {
          title: 'Create Labour & Price',
          icon: WorkIcon,
          href: '/SetupTenant/LabourPrice',
          id: 230
        },
        {
          title: 'Create User Type',
          icon: WorkIcon,
          href: '/SetupTenant/UserType',
          id: 390
        },
        {
          title: 'Create User Type For Employee',
          icon: WorkIcon,
          href: '/SetupTenant/UserTypeForEmployee',
          id: 400
        },
        {
          title: 'Create Transportation Rules',
          icon: LocalShippingIcon,
          href: '/SetupTenant/TransportationRules',
          id: 329
        },
        {
          title: 'Transportation Costs',
          icon: LocalShippingIcon,
          href: '/SetupTenant/TransportationCosts',
          id: 5190
        },
        {
          title: 'Create Warranty Types',
          icon: VerifiedUserIcon,
          href: '/SetupTenant/WarrantyType',
          id: 330
        },
        {
          title: 'Create NPS Translation',
          icon: TranslateIcon,
          href: '/SetupTenant/NpsTranslation',
          id: 340
        },
        {
          title: 'Create Status',
          icon: LiveHelp,
          href: '/SetupTenant/Status',
          id: 350
        },
        {
          title: 'Create Status Relation',
          icon: ReportProblemIcon,
          href: '/SetupTenant/StatusRelation',
          id: 360
        },
        {
          title: 'Creat Reject Reason',
          icon: ThumbDownAltIcon,
          href: '/SetupTenant/RejectReason',
          id: 370
        },
        {
          title: 'Create Exchange Reason',
          icon: SwapHorizontalCircleIcon,
          href: '/SetupTenant/ExchangeReason',
          id: 380
        },
        {
          title: 'Update Translations',
          icon: TranslateIcon,
          href: '/SetupTenant/UpdateTranslation',
          id: 390
        },
      ]
    },
    {
      title: t('Comment'),
      href: '/Chat',
      icon: CommentIcon
    },
    {
      title: t('Bulten'),
      href: '/Bulletin',
      icon: ImportContactsIcon
    },
    {
      title: t('lblProductRelease'),
      href: '/ProductRelease',
      icon: AssignmentIcon,

    },
    {
      title: t('Product Release Announcement'),
      href: '/ProductReleaseAnnouncement',
      icon: AssignmentIcon,

    },
    {
      title: t('lblTechnicalSupport'),
      href: '/TechnicalSupport',
      icon: SupportIcon
    },
    {
      title: t('lblHQSupport'),
      href: '/HQSupport',
      icon: HeadsetMicIcon
    },
    {
      title: t('TechnicalKnowledgeBased'),
      href: '/TechnicalKnowledgeBased',
      icon: LiveHelp
    },
    {
      title: 'Sales',
      href: '/Sales',
      icon: ShoppingCartIcon,
      items: [
        {
          title: 'Product For Sales',
          icon: AddShoppingCartIcon,
          href: '/Sales/ProductForSales',
          id: 250
        }
      ]
    }
  ];
};

export default StartMenu;
//////////////// YORUM /////////////////////////////
export const setYorumAdet = Adet => {
  sessionStorage.removeItem('YorumAdet');
  sessionStorage.setItem('YorumAdet', Adet);
};
